import { CheckCircle2, DoorOpen, Utensils, XCircle, Ghost, RotateCcw } from "lucide-react";

export const STATUS_LABELS = {
  da_confermare: "Da confermare", confermata: "Confermata", arrivato: "Arrivato",
  completata: "Completata", annullata: "Annullata", no_show: "No-show",
};

export const STATUS_STYLES = {
  da_confermare: "bg-amber-50 text-amber-900 border-amber-300",
  confermata: "bg-emerald-50 text-emerald-900 border-emerald-300",
  arrivato: "bg-sky-50 text-sky-900 border-sky-300",
  completata: "bg-sand-100 text-ink-700 border-sand-300",
  annullata: "bg-rose-50 text-rose-800 border-rose-200",
  no_show: "bg-orange-50 text-orange-900 border-orange-300",
};

export const STATUS_BAR = {
  da_confermare: "bg-amber-400", confermata: "bg-emerald-500", arrivato: "bg-sky-500",
  completata: "bg-ink-300", annullata: "bg-rose-300", no_show: "bg-orange-400",
};

// Azione principale contestuale (stesse transizioni valide della state machine).
export const PRIMARY_ACTION = {
  da_confermare: { to: "confermata", label: "Conferma", Icon: CheckCircle2 },
  confermata: { to: "arrivato", label: "Arrivato", Icon: DoorOpen },
  arrivato: { to: "completata", label: "Completa", Icon: Utensils },
};

export const SECONDARY_ACTIONS = {
  da_confermare: [{ to: "annullata", label: "Annulla", Icon: XCircle, danger: true }],
  confermata: [
    { to: "no_show", label: "No-show", Icon: Ghost, danger: true },
    { to: "annullata", label: "Annulla", Icon: XCircle, danger: true },
  ],
  arrivato: [{ to: "annullata", label: "Annulla", Icon: XCircle, danger: true }],
  completata: [], annullata: [], no_show: [],
};

export const RESTORE_ACTION = { to: "confermata", label: "Ripristina", Icon: RotateCcw, force: true };
export const RESTORABLE = ["annullata", "no_show", "completata"];

export const romeToday = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Rome" }).format(new Date());

export const shiftDay = (iso, n) => {
  const d = new Date(`${iso}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};

export const longDate = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString("it-IT", {
  weekday: "long", day: "numeric", month: "long", year: "numeric",
});
